import React, { useEffect, useRef, useState } from 'react';
import Instructions from '../components/instructions';
import Slider from 'react-input-slider';
import icon from '../images/icon-g.png';
import cartelD from '../images/cartel-d.png';
import cartelA from '../images/cartel-a.png';
import cartelT from '../images/cartel-t.png';
import cartelC from '../images/cartel-c.png';
import cartelF from '../images/cartel-f.png';




const NumericInputSlide = ({ actual }) => {

    const getInitialSliderValues = () => {
        const savedValues = JSON.parse(localStorage.getItem('selected6'));
        return savedValues || { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0 };
    };

    const [sliderValues, setSliderValues] = useState(getInitialSliderValues);


    const [sliderValue, setSliderValue] = useState(sliderValues.a);
    const [sliderValue2, setSliderValue2] = useState(sliderValues.b);
    const [sliderValue3, setSliderValue3] = useState(sliderValues.c);
    const [sliderValue4, setSliderValue4] = useState(sliderValues.d);
    const [sliderValue5, setSliderValue5] = useState(sliderValues.e)
    const [sliderValue6, setSliderValue6] = useState(sliderValues.f);

    const handleSliderChange = (value) => {
        setSliderValue(value);
        setSliderValues(prevValues => ({
            ...prevValues,
            a: value  // Asegurándose de utilizar value.x para obtener el valor del slider
        }));

    };
    const handleSliderChange2 = (value) => {
        setSliderValue2(value);
        setSliderValues(prevValues => ({
            ...prevValues,
            b: value  // Asegurándose de utilizar value.x para obtener el valor del slider
        }));
    };
    const handleSliderChange3 = (value) => {
        setSliderValue3(value);
        setSliderValues(prevValues => ({
            ...prevValues,
            c: value  // Asegurándose de utilizar value.x para obtener el valor del slider
        }));
    };
    const handleSliderChange4 = (value) => {
        setSliderValue4(value);
        setSliderValues(prevValues => ({
            ...prevValues,
            d: value  // Asegurándose de utilizar value.x para obtener el valor del slider
        }));
    };
    const handleSliderChange5 = (value) => {
        setSliderValue5(value);
        setSliderValues(prevValues => ({
            ...prevValues,
            e: value  // Asegurándose de utilizar value.x para obtener el valor del slider
        }));
    };
    const handleSliderChange6 = (value) => {
        setSliderValue6(value);
        setSliderValues(prev => ({ ...prev, f: value }));
    };


   // 5 opciones (0..4)
const getWordFromValue = (value) => {
  const words = ['Seco', 'Casi seco', 'Semiseco', 'Semidulce', 'Muy dulce'];
  return words[value] ?? '';
};

const getWordFromValue2 = (value) => {
  const words = ['Baja', 'Media(-)', 'Media', 'Media(+)', 'Alta'];
  return words[value] ?? '';
};

const getWordFromValue3 = (value) => {
  const words = ['Bajo', 'Medio(-)', 'Medio', 'Medio(+)', 'Alto'];
  return words[value] ?? '';
};

const getWordFromValue4 = (value) => {
  const words = ['Poco', 'Medio(-)', 'Medio', 'Medio(+)', 'Mucho'];
  return words[value] ?? '';
};

const getWordFromValue5 = (value) => {
  const words = ['Corto', 'Medio(-)', 'Medio', 'Medio(+)', 'Largo'];
  return words[value] ?? '';
};

const getWordFromValue6 = (value) => {
  const words = ['Bajo', 'Medio', 'Alto'];
  return words[value] ?? '';
};

    const [title, setTitle] = useState(null);
    useEffect(() => {
        const savedTest = JSON.parse(localStorage.getItem('currentTest') || '[]');
        setTitle(savedTest.title);
        localStorage.setItem('selected6', JSON.stringify(sliderValues));
    }, [sliderValues]);
    useEffect(() => {
        const nextButton = document.querySelector('.btn-next');

        nextButton.disabled = false; // Habilitar el botón

    });
    return (
        <div className="slide-container">
            <Instructions phase="taste" />
            <div className="actual-wine">{title}</div>
            <h2>Fase gustativa</h2>
            <div className="sliders-container">
                <div className="line line-a">
                    <div className="line-image">Dulzor</div>
                    <div className="input-slider-container slider0">
                        <div className="input-info">{getWordFromValue(sliderValue)}</div>
                        <Slider axis="x" x={sliderValue} xmax={4} onChange={({ x }) => handleSliderChange(x)} styles={{active: {backgroundColor: '#BB4F4D'}}}/>
                        
                    </div>
                </div>
                <div className="line line-b">
                    <div className="line-image">Acidez</div>
                    <div className="input-slider-container slider2">
                        <div className="input-info">{getWordFromValue2(sliderValue2)}</div>
                        <Slider axis="x" x={sliderValue2} xmax={4} onChange={({ x }) => handleSliderChange2(x)} styles={{active: {backgroundColor: '#BB4F4D'}}}/>
                        
                    </div>
                </div>
                <div className="line line-c">
                    <div className="line-image">Tanino</div>
                    <div className="input-slider-container slider3">
                        <div className="input-info">{getWordFromValue3(sliderValue3)}</div>
                        <Slider axis="x" x={sliderValue3} xmax={4} onChange={({ x }) => handleSliderChange3(x)} styles={{active: {backgroundColor: '#BB4F4D'}}}/>
                        
                    </div>
                </div>
                <div className="line line-f">
                    <div className="line-image">Alcohol</div>
                    <div className="input-slider-container slider6">
                        <div className="input-info">{getWordFromValue6(sliderValue6)}</div>
                        <Slider axis="x" x={sliderValue6} xmax={2} onChange={({ x }) => handleSliderChange6(x)} styles={{active: {backgroundColor: '#BB4F4D'}}}/>
                        
                    </div>
                </div>
                <div className="line line-d">
                    <div className="line-image">Cuerpo</div>
                    <div className="input-slider-container slider4">
                        <div className="input-info">{getWordFromValue4(sliderValue4)}</div>
                        <Slider axis="x" x={sliderValue4} xmax={4} onChange={({ x }) => handleSliderChange4(x)} styles={{active: {backgroundColor: '#BB4F4D'}}}/>
                        
                    </div>
                </div>
                <div className="line line-e">
                    <div className="line-image">Final</div>
                    <div className="input-slider-container slider5">
                        <div className="input-info">{getWordFromValue5(sliderValue5)}</div>
                        <Slider axis="x" x={sliderValue5} xmax={4} onChange={({ x }) => handleSliderChange5(x)} styles={{active: {backgroundColor: '#BB4F4D'}}}/>
                        
                    </div>
                </div>
                
            </div>
        </div>
    );
};

export default NumericInputSlide;
